// extracted by mini-css-extract-plugin
export default {"root":"TimeRestrictionsGroup_root__+GAQY","placeHolderShimmer":"TimeRestrictionsGroup_placeHolderShimmer__atK7x"};